.header {
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom: 1px solid var(--gz-line);
  background: color-mix(in srgb, var(--gz-bg) 86%, transparent);
  backdrop-filter: blur(18px) saturate(1.3);
}

.inner {
  display: flex;
  align-items: center;
  gap: 1rem;
  height: var(--header-height);
  max-width: 1280px;
  margin-inline: auto;
  padding-inline: 1.25rem;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: 760;
  font-size: 1.0625rem;
  letter-spacing: -0.02em;
  color: var(--gz-fg);
  text-decoration: none;

  small {
    padding: 0.18rem 0.38rem;
    border: 1px solid var(--gz-line);
    border-radius: 999px;
    color: var(--zen-text-muted);
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.04em;
  }
}

.nav {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-inline-start: auto;
  font-size: 0.9rem;

  a {
    color: var(--zen-text-secondary);
    text-decoration: none;

    &:hover { color: var(--gz-fg); }
  }
}

.docsLink {
  padding: 0.5rem 0.7rem;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;

  &:hover { background: var(--zen-bg-elevated); }
}

.language {
  position: relative;

  > button {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    border: 1px solid var(--gz-line);
    min-height: 34px;
    border-radius: 8px;
    padding: 0.3rem 0.65rem;
    font-size: 0.8rem;
    color: var(--gz-muted);
    background: var(--zen-bg-surface);
    cursor: pointer;

    &:hover { color: var(--gz-accent); border-color: var(--gz-accent); }
  }

  ul {
    position: absolute;
    inset-inline-end: 0;
    z-index: 50;
    margin-top: 0.5rem;
    max-height: 70vh;
    width: 11rem;
    overflow-y: auto;
    list-style: none;
    padding: 0.35rem;
    border: 1px solid var(--gz-line);
    border-radius: 10px;
    background: var(--gz-surface);
    box-shadow: 0 18px 40px rgb(0 0 0 / 35%);

    button {
      display: block;
      width: 100%;
      border: 0;
      border-radius: 6px;
      padding: 0.4rem 0.7rem;
      text-align: start;
      font-size: 0.85rem;
      color: var(--gz-muted);
      background: none;
      cursor: pointer;

      &:hover { background: var(--gz-surface-2); color: var(--gz-fg); }
    }
  }
}

.active { color: var(--gz-accent) !important; }

.iconButton {
  display: inline-grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border: 1px solid var(--gz-line);
  border-radius: 8px;
  background: var(--zen-bg-surface);
  color: var(--zen-text-secondary);
  cursor: pointer;

  &:hover {
    border-color: color-mix(in srgb, var(--gz-accent) 60%, var(--gz-line));
    color: var(--gz-accent);
  }
}

@media (max-width: 560px) {
  .inner { padding-inline: 1rem; }
  .docsLink,
  .iconButton:last-child { display: none; }
  .language > button span { display: none; }
  .language > button { width: 34px; justify-content: center; padding: 0; }
}
